module.exports = __webpack_public_path__ + "static/media/paco-rabanne-ultraviolet-man-big.f4ce6d31.png";